import React from "react";
import { Link } from "react-router-dom";

import "../../Products/Products.css"

const ProductsSection = () => {


  return (
    <div className="my-5 services-container">
      <h2 className="text-center blue-color">
        <i className="fas fa-flask"></i> Request Product
      </h2>
      <p className="text-center fs-5">Additional information about the product</p>
      <div className="container">
     
        <Link to="/products" className="text-decoration-none">
          <button className="btn btn-secondary d-block mx-auto">More Products</button>
        </Link>
      </div>
    </div>
  );
};

export default ProductsSection;
